// extracted by mini-css-extract-plugin
module.exports = {"termsWrapper":"style_termsWrapper__8A1IJ"};